
// import $ from "jquery";
import {showCalendarItem} from "../../scripts/calendar.js";
import breadcrumb from './breadcrumb';
import "../../../node_modules/@prokomssp/fantdu/dist/fantdu.min.js";


export default function(){
    
    showCalendarItem();
    const breadcrumbHtml = breadcrumb();
    let nameId = client.nameId || "";
    
    
    return `
    
        <div class="container">
            ${breadcrumbHtml}
        </div>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="calendar__event__container">
                    
                        
                        <div class="spinner-border align-self-center" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                                        
                    
                    </div>
                </div>
            </div>
        </div>
        <div class="fant_du_container">
            <fant-du client="${nameId}"></fant-du> 
        </div>
        
    `;
}